// Dashboard.js
import React from "react";

const Dashboard = () => {
  return (
    <div className="dashboard">
      <div className="dashboard-section">
        <h2>Subject Progress</h2>
        {/* Add content related to Subject Progress */}
      </div>
      <div className="dashboard-section">
        <h2>Upcoming Class</h2>
        {/* Add content related to Upcoming Class */}
      </div>
      <div className="dashboard-section">
        <h2>Homework</h2>
        {/* Add content related to Homework */}
      </div>
      <div className="dashboard-section">
        <h2>Alert</h2>
        {/* Add content related to Alert */}
      </div>
    </div>
  );
};

export default Dashboard;
